
<div class="section__title border-top-title">
    <h1>Carga de archivos</h1>
</div>
<table id="tblfileload" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table dense__table table-striped data-tables w-100">
    <thead>
        <tr>
            <th rowspan="2">Fecha de carga</th>
            <th rowspan="2">Usuario</th>
            <th rowspan="2">Archivo</th>
            <th colspan="2">Total Registros</th>
            <th colspan="2">Alta de concesionarios</th>
            <th colspan="2">Actualización de concesionarios</th>
            <th colspan="2">Alta de instalaciones</th>
            <th colspan="2">Actualización de instalaciones</th>
            <th rowspan="2">Sugerencias de baja</th>
            <th rowspan="2">Estado</th>
            <th rowspan="2" width="92px">Opciones</th>
        </tr>
        <tr>
            <th>Leídos</th>
            <th>Cargados</th>
            <th>OK</th>
            <th>ERROR</th>
            <th>OK</th>
            <th>ERROR</th>
            <th>OK</th>
            <th>ERROR</th>
            <th>OK</th>
            <th>ERROR</th>
        </tr>
    </thead>
</table>